import React from 'react';
import { FormattedMessage } from 'react-intl';

import ProductPage from '../../components/ProductPage';
import Layout from '../../components/Layout';
import messages from './messages';

const pricing = [
  {
    title: messages.standard,
    monthlyPrice: 4,
    monthlyPayment: messages.monthlyPayment,
    limitMessage: messages.limitMessageStandard,
    featureList: [
      messages.featureTrackTime,
      messages.featureTrackHolidays,
      messages.featureGitlab,
      messages.featureGitlabIssue,
      messages.featureJira,
      messages.featureLogins,
      messages.featureBillable,
      messages.featureAdminSupervice,
      messages.featureAdminCustomProjects,
      messages.featureAdminExport,
    ],
    buyLink: 'mailto:sales@waltzing.at',
  },
  {
    title: messages.pro,
    monthlyPrice: 7,
    monthlyPayment: messages.monthlyPayment,
    limitMessage: messages.limitMessagePro,
    featureList: [
      messages.featureTeamControllingAll,
      messages.featureTeamControllingIndividual,
      messages.featureShortWork,
      messages.featureShortWorkFilter,
      messages.featureShortWorkExport,
    ],
    featureHeaderText: messages.featureHeaderTextPro,
    buyLink: 'mailto:sales@waltzing.at',
  },
  {
    title: messages.onPremise,
    monthlyPrice: 7,
    monthlyPayment: messages.monthlyPayment,
    limitMessage: messages.limitMessageOnPremise,
    featureList: [
      messages.featureDockerized,
      messages.featureTimeTrackingInHouse,
    ],
    featureHeaderText: messages.featureHeaderTextOnPremise,
    buyLink: 'mailto:sales@waltzing.at',
  },
];

class Time extends React.Component {
  render() {
    return (
      <Layout>
        <ProductPage
          headerImg={'/product/Waltzing-Time-Mockup_low-quality.jpg'}
          logoImg={'/product/time.svg'}
          productName="Waltzing Time"
          productDescription={<FormattedMessage {...messages.description} />}
          pricing={pricing}
        />
      </Layout>
    );
  }
}

export default Time;



// WEBPACK FOOTER //
// ./src/routes/time/index.js